<template>
  <div class="overlay">
    <service-channels-popup
        v-if="serviceChannelsPopupData"
        :popup-data="serviceChannelsPopupData"
        :show-channel-sort="true"
        @close="serviceChannelsPopupData = null"
    ></service-channels-popup>
    <div class="overlay_inner service_list_popup">
      <search-input
          :show-label="false"
          p-class="field search-field"
          input-class="search clearable"
          :input-placeholder="'Vyhledat službu' | translate"
          v-model="search"
          ref="searchavailableserviceref"
      ></search-input>
      <p class="note" v-translate>Vyberte služby, které chcete odběrateli přiřadit</p>
      <service-filter-by-property
          ref="serviceFilterByPropertyRef"
          :show-pack-button="true"
          :is-all-unpacked="this.isAllUnpacked"
          @unpackAll="unpackAll()"
          @packAll="packAll()"
          v-model="propertyFilter"
      />
      <div class="service_list">
        <div :class="['service_item', {disabled: !isServiceActive(service)}]" v-for="service in filteredServices" :key="'item-'+service.id">

          <div :class="['service_header', {active: showDetails(service.id)}]" @click="toggleDetails(service.id)">
            <div class="service_name">
              <p class="select_service">
                <input type="checkbox"
                       :id="service.id"
                       :value="service.id"
                       v-model="selectedServices"
                       :ref="'checkbox-' + service.id"
                />
                <label :for="service.id" v-translate>Vybrat</label>
              </p>
              <h3><a @click="onServiceNameClick(service.id)">{{service.name}}</a></h3>
              <span>&nbsp;&nbsp;</span> <a
                  v-if="$_loggedUser_action_allowed('services', 'read')"
                  class="service_info"
                  :title="$gettext('Info o službě')"
                  @click.prevent.stop="onServiceInfoClick(service.id)"
                  v-translate>Info
              </a>
            </div>
            <services-icons
                v-show="!showDetails(service.id)"
                :service-type="'available'"
                :service-data=getServiceData(service)
                :inline="true"
                @showChannels="loadAvailableServiceChannelsPopupData(service.id)"
            >
            </services-icons>
            <div class="service_header_status">
              <p class="service_validity">
                <span v-if="hasAnyValidity(service)">
															<span>{{ serviceValidity(service) }}</span>
                </span>
              </p>
            </div>
          </div>
          <div :id="'wrapper-'+service.id" v-show="showDetails(service.id)">
          <services-icons
              :service-type="'available'"
              :service-data=getServiceData(service)
              @showChannels="loadAvailableServiceChannelsPopupData(service.id)"
          >
          </services-icons>
            </div>
        </div>
      </div>

      <p class="buttons" >
        <a :class="[{'btn_inactive': !allowAddServices}, 'btn']" @click="onAddServicesClick" v-translate>Přiřadit</a>
      </p>

      <a @click="onClose" class="btn btn_action btn_close" :title="$gettext('Zavřít')" v-translate>Zavřít</a>
    </div>
  </div>

</template>

<script>
import subscriberService from "../mixins/subscriberService";
import serviceChannelsPopup from "./ServiceChannelsPopup.vue";
import servicesIcons from "./ServicesIcons.vue";
import serviceFilterByProperty from "./ServiceFilterByProperty.vue";

export default {
  name: "AvailableServicesList",
  mixins: [subscriberService],
  props:{
    services: Array,
  },
  components: {
    servicesIcons,
    serviceChannelsPopup,
    serviceFilterByProperty
  },
  data(){
    return {
      showList: {},
      selectedServices: [],
      isAllUnpacked: false,
    }
  },
  created() {
    this.isAvailableServices = true;
    this.$nextTick(() => {
      this.$refs['searchavailableserviceref'].$refs['vyhledavaniref'].focus();
    });
  },
  computed: {
    allowAddServices(){
      return this.selectedServices.length > 0;
    },
  },
  methods:{
    hasAnyValidity(service){
      return service.valid_from != null || service.valid_to != null;
    },
    serviceValidity(service) {
      let validity = ''
      let finalActiveFrom = service.valid_from
      let finalActiveTo = service.valid_to
      if (finalActiveFrom) {
        validity += this.$gettext('Platnost od') + " " + finalActiveFrom
        if (finalActiveTo) {
          validity += ' – ' + finalActiveTo
        }
        return validity
      }
      if (finalActiveTo) {
        validity += this.$gettext('Platnost do') + " " + finalActiveTo
        return validity
      }
      return validity
    },
    onClose(){
      this.$emit('close');
    },
    onServiceNameClick(id){
      const checkbox = this.$refs['checkbox-' + id][0];
      if (checkbox){
        checkbox.click();
      }
    },
    loadAvailableServiceChannelsPopupData(serviceId) {
      let service = this.getServiceByServiceId(this.services, serviceId)
      this.loadServiceChannelsPopupData(service['id_channels_including_from_channel_packages'], service['summed'])
    },
    showDetails(idService){
      if(this.showList.hasOwnProperty(idService)){
        return this.showList[idService];
      }
      return false;
    },
    toggleDetails(idService){
      if(this.showList.hasOwnProperty(idService)){
        this.$set(this.showList, idService, !this.showList[idService]);
      }else{
        this.$set(this.showList, idService, true);
      }
      this.checkIsAllPacked();
    },
    unpackAll(){
      this.filteredServices.forEach((item) => {
        this.$set(this.showList, item.id, true)
      })
      this.isAllUnpacked = true;
    },
    packAll(){
      this.filteredServices.forEach((item) => {
        this.$set(this.showList, item.id, false)
      })
      this.isAllUnpacked = false;
    },
    checkIsAllPacked(){
      this.isAllUnpacked = this.filteredServices.every(service => this.showList[service.id] === true);
    },
    onAddServicesClick(){
      if(this.allowAddServices) {
        this.$emit('add', this.selectedServices)
      }
    }
  },
  watch:{
    filteredServices(){
      this.checkIsAllPacked();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/subscribers/servicesList/AvailableServicesList.vue